import { z } from '@betty/toolkit/api';
import {
  PaymentDetailsSchema,
  PaymentProvidersSchema,
  TransactionStatusSchema,
  UnverifiedPaymentMethodSchema,
  VerifyInteracEmailSchema,
  VerifyInteracEmailResultSchema,
} from '../../services/PaymentService/PaymentService.schemas';

export type PaymentProviders = z.infer<typeof PaymentProvidersSchema>;

export type PaymentDetails = z.infer<typeof PaymentDetailsSchema>;

export type TransactionStatus = z.infer<typeof TransactionStatusSchema>;

export type UnverifiedPaymentMethod = z.infer<
  typeof UnverifiedPaymentMethodSchema
>;

export type PaymentEntityId = UnverifiedPaymentMethod['paymentEntityId'];

export type TransactionStatusParams = {
  transactionId?: string;
  externalTransactionId?: string;
};

export type InteracEmailVerification = z.infer<typeof VerifyInteracEmailSchema>;

export type InteracEmailVerificationResult = z.infer<
  typeof VerifyInteracEmailResultSchema
>;

export enum Payment {
  Visa = 'Visa',
  Interac = 'Interac',
  Mastercard = 'Mastercard',
  ApplePay = 'ApplePay',
}
